var _g, _g2, _circle, _g3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBg2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1440 1024",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1146_15997)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 796.243,
    cy: 931.242,
    r: 138.186,
    transform: "rotate(19.6524 796.243 931.242)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.7,
    cx: 796.243,
    cy: 931.242,
    r: 138.186,
    transform: "rotate(19.6524 796.243 931.242)",
    fill: "url(#paint0_linear_1146_15997)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_1146_15997)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 724.012,
    cy: 133.012,
    r: 98.1035,
    transform: "rotate(30 724.012 133.012)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 724.012,
    cy: 133.012,
    r: 98.1035,
    transform: "rotate(30 724.012 133.012)",
    fill: "url(#paint1_linear_1146_15997)"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1261.85,
    cy: 514.847,
    r: 593.847,
    transform: "rotate(-76.4986 1261.85 514.847)",
    fill: "url(#paint2_linear_1146_15997)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_1146_15997)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1397.16,
    cy: 45.1627,
    r: 90.8934,
    transform: "rotate(30 1397.16 45.1627)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.7,
    cx: 1397.16,
    cy: 45.1627,
    r: 90.8934,
    transform: "rotate(30 1397.16 45.1627)",
    fill: "url(#paint3_linear_1146_15997)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1146_15997",
    x: 518.02,
    y: 653.019,
    width: 556.448,
    height: 556.448,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 70,
    result: "effect1_foregroundBlur_1146_15997"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_1146_15997",
    x: 485.892,
    y: -105.108,
    width: 476.24,
    height: 476.24,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 70,
    result: "effect1_foregroundBlur_1146_15997"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_1146_15997",
    x: 1166.25,
    y: -185.746,
    width: 461.817,
    height: 461.817,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 70,
    result: "effect1_foregroundBlur_1146_15997"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1146_15997",
    x1: 715.036,
    y1: 825.806,
    x2: 899.017,
    y2: 1041.47,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#40C4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1146_15997",
    x1: 666.36,
    y1: 58.1583,
    x2: 796.975,
    y2: 211.268,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F44336"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1146_15997",
    x1: 912.862,
    y1: 61.7379,
    x2: 1703.51,
    y2: 988.552,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0CD09F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1146_15997",
    x1: 1343.75,
    y1: -24.1895,
    x2: 1464.76,
    y2: 117.667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC91D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg2);
export default __webpack_public_path__ + "static/media/bg-2.7d9628f8d9a803f1cf98188cd83edc72.svg";
export { ForwardRef as ReactComponent };